import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const restoreExecutiveSummaryFileContent: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<void> = (fetchContext, nominationId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/nominations/${nominationId}/executive-summary-file-content/restoration`,
  {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'restore executive summary file content'));
